// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white-100: #EDEDF0;
  --white: #ffffff;
  --white-1: rgba(255, 255, 255, 0.1);
  --white-02: rgba(255, 255, 255, 0.02);
  --white-4: rgba(255, 255, 255, 0.4);
  --white-5: rgba(255, 255, 255, 0.5);
  --white-08: rgba(255, 255, 255, 0.08);
  --white-6: #EDEDF0;
  --black: #000000;
  --black-900: #050505;
  --textBlack: #393838;
  --black-25: rgba(0, 0, 0, 0.25);
  --black-35: rgb(0, 0, 0, 0.35);
  --btnText: rgb(111 60 0 / 81%);
  --darkText: #393838;
  --bgPrimary: #1C1C1C;
  --primaryBtn: #FFE500;
  --historyYellow: #453F02;
  --historyRed: #450A0A;
  --historyRedText: #F87171;
  --historyBlue: #172554;
  --historyBlueText: #60A5FA;
  --historyGreen: #022C22;
  --historyGreenText: #10B981;
  --historyGray: #222223;
  --historyGrayText: #A1A1AA;
  --gameSidebarBg: linear-gradient(91.76deg, rgba(32, 30, 30, 1) 0%, rgba(32, 30, 30, 1) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.02) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);
  --gameInputBg: linear-gradient(91.76deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.35) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.06) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);
  --gameContainerOverlay: linear-gradient(91.76deg, rgba(32, 30, 30, 0.9) 0%, rgba(32, 30, 30, 0.75) 53.12%, rgba(32, 30, 30, 0.9) 100%);
  --gameNumbersSaperatorBg: linear-gradient(270deg, #FFE500 0%, rgba(254, 224, 64, 0.25) 100%);
  --primary-300: #928403;
  --primary-600: #FFD600;
  --zinc-600: #52525B;
  --zinc-650: #4C4C52;
  --zinc-700: #3F3F46;
  --zinc-800: #27272A;
  --zinc-850: #333333;
  --zinc-900: #18181B;
  --zinc-950: #09090B;
  --zinc-950-06: rgba(9, 9, 11, 0.6);
  --zinc-950-07: rgba(9, 9, 11, 0.7);
  --black: #000000;
  --black-20: #00000033;
  --black-30: rgb(0 0 0 / 30%);
  --gray-100-21: rgba(79, 79, 79, 0.21);
  --gray-200: #696969;
  --gray-300: #B8B8B8;
  --gray-400: #949494;
  --gray-700: #3D3D43;
  --gray-750: #272727;
  --gray-800: #10473A;
  --gray-850-32: rgba(35, 35, 35, 0.32);
  --gray-850: #2A2A31;
  --gray-900: #191A1E;
  --gray-950: #232323;
  --gray-900-15: rgb(126 126 126 / 21%);
  --gray-975: #040404;
  --yellow-200-04: rgba(255, 230, 0, 0.4);
  --yellow-200-20: rgba(255, 229, 0, 0.20);
  --yellow-200-24: rgba(255, 230, 0, 0.24);
  --yellow-200-30: rgba(255, 229, 0, 0.30);
  --yellow-200-54: rgba(255, 230, 0, 0.54);
  --yellow-300-60: rgba(255, 230, 117, 0.60);
  --yellow-200-61: rgba(255, 222, 82, 0.61);
  --yellow-400: #F6D76B;
  --yellow-500: #F6C36B;
  --yellow-600: #FFE353;
  --yellow-700: #FFE500;
  --yellow-800: #EBC500;
  --yellow-900: #443D00;
  --pink-300: #FE6969;
  --pink-400: #E7635E;
  --pink-600: #E34A5C;
  --orange-300: #F0A265;
  --orange-350: #F39946;
  --orange-400: #F4754D;
  --orange-500: #FF5C00;
  --orange-900: #44190C;
  --red-100: #F1313E;
  --red-500: #EF4444;
  --red-500-2: rgba(239, 68, 68, 0.2);
  --red-600: #F80027;
  --red-900: #200000;
  --cyan-400: #7EFFF0;
  --cyan-900: #02312C;
  --purple-100-08: rgba(179, 19, 255, 0.08);
  --purple-100-30: rgba(179, 19, 255, 0.30);
  --purple-200: #0689FF;
  --purple-400: #8000FF;
  --purple-500: #B313FF;
  --purple-600-04: rgba(98, 1, 255, 0.4);
  --purple-600-54: rgba(98, 1, 255, 0.54);
  --purple-600-24: rgba(98, 1, 255, 0.24);
  --purple-600-66: rgba(129, 59, 242, 0.66);
  --purple-600-04: rgba(98, 1, 255, 0.4);
  --green-400: #3ED179;
  --gameContainerBg: #10473A;
  --btn-grey-primary: #252838;
  --purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);
  --purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);
  --purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),
    radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);
  --plinkoBgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);
  --plinkoSidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);
  --primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;
  --input-ps: 0.75rem;
  --input-pe: 0.75rem;
  --dice-primary-main: #8953FC;
  --dice-primary-800: #F57F31;
  --dice-primary-main-2: rgba(137, 83, 252, 0.2);
  --dice-green-main: #2CB575;
  --dice-dark-700-75: rgba(10, 12, 18, 0.75);
  --dice-grey-100: #D9D9D9;
  --dice-grey-200: #B4B6C1;
  --dice-grey-300: #9598A7;
  --dice-grey-400: #686C81;
  --dice-red-main: #B52C2C;
  --dice-high-blue: #349DD9;
  --dice-orange-main: #FF8800;
  --dice-blue-focus-2: rgba(0, 92, 230, 0.2);
  --dice-blue-pressed: #0040A1;
  --dice-neutral-100: #303444;
  --dice-neutral-200: #333748;
  --dice-neutral-300: #246D5A;
  --dice-neutral-400: #1E212F;
  --dice-neutral-500: #10473A;
  --dice-neutral-600: #0B2A23;
  --dice-neutral-700: #0F3930;
  --dice-neutral-800: #0D0F15;
  --dice-neutral-900: #0A0C12;
  --dice-interface-800: #292A34;
  --plinko-history-btn-100: #FFB74C;
  --plinko-history-btn-200: #FF9C2B;
  --plinko-history-btn-300: #FF8800;
  --plinko-history-btn-400: #FE2813;
  --plinko-history-btn-500: #FF0083;
  --plinko-history-btn-600: #8953FC;
  --plinko-history-btn-700: #9603FA;
  --plinko-history-btn-800: #0385FF;
  --plinko-history-btn-900: #04B2AC;
  --primary-surface: #3A236A;
  --gameMineGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
    linear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);
  --range-slider-primary-bg: #246D5A;
  --range-slider-secondary-bg: #10473A;
  --hilo-btn: linear-gradient(180deg, #03A5D9 0%, #03789D 100%);
  --hilo-btn-hover: linear-gradient(180deg, #03789D 0%, #03A5D9 100%);
  --hilo-tile-hover: #494E67;
  --hilo-card: #8F8F8F;
  --hilo-card-hover: #000000B2;
  --diceRangeColor-1: #B6C649;
  --diceRangeColor-2: #F57F31;
  --bet-history-dice-green: #B6C649;
  --bet-history-dice-red: #246D5A;
  --tooltip-payout: #D9D9D9;
  --tooltip-payout-date: #246D5A;
}

.dark-theme {
  --gray-800: #202022;
  --dice-neutral-700: #101010;
  --dice-primary-800: #FECB46;
  --dice-neutral-300: #F1C24C;
  --white: #fff;
  --white-100: #9598A7;
  --dice-neutral-600: #171717;
  --dice-neutral-800: #202022;
  --gameContainerBg: #202022;
  --neutral-300: #292C39;
  --configModal: #1E212F;
  --dice-neutral-500: #202022;
  --riskActiveBbtn: #FEEBB9;
  --multiplier-100: #5C91BC;
  --multiplier-200: #8F52BF;
  --multiplier-300: #CC9B5A;
  --multiplier-400: #BC5550;
  --hilo-card-multiply: #212121;
  --range-slider-primary-bg: #F1C24C;
  --range-slider-secondary-bg: #202022;
  --bet-history-dice-green: #F1C24C;
  --bet-history-dice-red: #171717;
  --diceRangeColor-2: #FED569;
  --diceRangeColor-1: #8C6A26;
  --tooltip-payout: #171717;
}

.light-theme {
  --dice-neutral-700: #000;
  --gameContainerBg: #fff;
  --gray-800: #000;
  --dice-neutral-300: #48F4FF;
  --dice-neutral-600: #3D3D3D;
  --livestate-li: #1e1e1e;
  --input-arrow-icon: #686C81;
  --input-multiplier: #3D3D3D;
  --border: #292C39;
  --configure-modal-bg: #0A0A0A;
  --configure-modal-btn: #48F4FF;
  --configure-modal-bottom: #171717;
  --footer-svg: #8E8E8E;
  --riskBtnColor: #202022;
  --TooltipBg: #D2D2D2;
  --DiceBgColor: #151515;
  --DiceGameBorder: #855BFC;
  --SkipCardBorder: #B4B4B4;
  --diceRangeColor-1: #48F4FF;
  --diceRangeColor-2: #855BFC;
  --range-slider-primary-bg: #48F4FF;
  --range-slider-secondary-bg: #202022;
  --bet-history-dice-green: #48F4FF;
  --bet-history-dice-red: #1E1E1E;
  --tooltip-payout: #171717;
}

.default {
  --white-100: #EDEDF0;
  --white: #ffffff;
  --white-1: rgba(255, 255, 255, 0.1);
  --white-02: rgba(255, 255, 255, 0.02);
  --white-4: rgba(255, 255, 255, 0.4);
  --white-5: rgba(255, 255, 255, 0.5);
  --white-08: rgba(255, 255, 255, 0.08);
  --white-6: #EDEDF0;
  --black: #000000;
  --black-900: #050505;
  --textBlack: #393838;
  --black-25: rgba(0, 0, 0, 0.25);
  --black-35: rgb(0, 0, 0, 0.35);
  --btnText: rgb(111 60 0 / 81%);
  --darkText: #393838;
  --bgPrimary: #1C1C1C;
  --primaryBtn: #FFE500;
  --historyYellow: #453F02;
  --historyRed: #450A0A;
  --historyRedText: #F87171;
  --historyBlue: #172554;
  --historyBlueText: #60A5FA;
  --historyGreen: #022C22;
  --historyGreenText: #10B981;
  --historyGray: #222223;
  --historyGrayText: #A1A1AA;
  --gameSidebarBg: linear-gradient(91.76deg, rgba(32, 30, 30, 1) 0%, rgba(32, 30, 30, 1) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.02) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);
  --gameInputBg: linear-gradient(91.76deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.35) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.06) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);
  --gameContainerOverlay: linear-gradient(91.76deg, rgba(32, 30, 30, 0.9) 0%, rgba(32, 30, 30, 0.75) 53.12%, rgba(32, 30, 30, 0.9) 100%);
  --gameNumbersSaperatorBg: linear-gradient(270deg, #FFE500 0%, rgba(254, 224, 64, 0.25) 100%);
  --primary-300: #928403;
  --primary-600: #FFD600;
  --zinc-600: #52525B;
  --zinc-650: #4C4C52;
  --zinc-700: #3F3F46;
  --zinc-800: #27272A;
  --zinc-850: #333333;
  --zinc-900: #18181B;
  --zinc-950: #09090B;
  --zinc-950-06: rgba(9, 9, 11, 0.6);
  --zinc-950-07: rgba(9, 9, 11, 0.7);
  --black: #000000;
  --black-20: #00000033;
  --black-30: rgb(0 0 0 / 30%);
  --gray-100-21: rgba(79, 79, 79, 0.21);
  --gray-200: #696969;
  --gray-300: #B8B8B8;
  --gray-400: #949494;
  --gray-700: #3D3D43;
  --gray-750: #272727;
  --gray-800: #1A1C28;
  --gray-850-32: rgba(35, 35, 35, 0.32);
  --gray-850: #2A2A31;
  --gray-900: #191A1E;
  --gray-950: #232323;
  --gray-900-15: rgb(126 126 126 / 21%);
  --gray-975: #040404;
  --yellow-200-04: rgba(255, 230, 0, 0.4);
  --yellow-200-20: rgba(255, 229, 0, 0.20);
  --yellow-200-24: rgba(255, 230, 0, 0.24);
  --yellow-200-30: rgba(255, 229, 0, 0.30);
  --yellow-200-54: rgba(255, 230, 0, 0.54);
  --yellow-300-60: rgba(255, 230, 117, 0.60);
  --yellow-200-61: rgba(255, 222, 82, 0.61);
  --yellow-400: #F6D76B;
  --yellow-500: #F6C36B;
  --yellow-600: #FFE353;
  --yellow-700: #FFE500;
  --yellow-800: #EBC500;
  --yellow-900: #443D00;
  --pink-300: #FE6969;
  --pink-400: #E7635E;
  --pink-600: #E34A5C;
  --orange-300: #F0A265;
  --orange-350: #F39946;
  --orange-400: #F4754D;
  --orange-500: #FF5C00;
  --orange-900: #44190C;
  --red-500: #EF4444;
  --red-500-2: rgba(239, 68, 68, 0.2);
  --red-600: #F80027;
  --red-900: #200000;
  --cyan-400: #7EFFF0;
  --cyan-900: #02312C;
  --purple-100-08: rgba(179, 19, 255, 0.08);
  --purple-100-30: rgba(179, 19, 255, 0.30);
  --purple-200: #0689FF;
  --purple-400: #8000FF;
  --purple-500: #B313FF;
  --purple-600-04: rgba(98, 1, 255, 0.4);
  --purple-600-54: rgba(98, 1, 255, 0.54);
  --purple-600-24: rgba(98, 1, 255, 0.24);
  --purple-600-66: rgba(129, 59, 242, 0.66);
  --purple-600-04: rgba(98, 1, 255, 0.4);
  --green-400: #3ED179;
  --gameContainerBg: #1B1E2E;
  --btn-grey-primary: #252838;
  --purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);
  --purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);
  --purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),
    radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);
  --plinkoBgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);
  --plinkoSidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);
  --primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;
  --input-ps: 0.75rem;
  --input-pe: 0.75rem;
  --dice-primary-main: #8953FC;
  --dice-primary-800: #6238BB;
  --dice-primary-main-2: rgba(137, 83, 252, 0.2);
  --dice-green-main: #2CB575;
  --dice-dark-700-75: rgba(10, 12, 18, 0.75);
  --dice-grey-100: #D9D9D9;
  --dice-grey-200: #B4B6C1;
  --dice-grey-300: #9598A7;
  --dice-grey-400: #686C81;
  --dice-red-main: #B52C2C;
  --dice-high-blue: #349DD9;
  --dice-orange-main: #FF8800;
  --dice-blue-focus-2: rgba(0, 92, 230, 0.2);
  --dice-blue-pressed: #0040A1;
  --dice-neutral-100: #303444;
  --dice-neutral-200: #333748;
  --dice-neutral-300: #292C39;
  --dice-neutral-400: #1E212F;
  --dice-neutral-500: #1A1C28;
  --dice-neutral-600: #151721;
  --dice-neutral-700: #11131B;
  --dice-neutral-800: #0D0F15;
  --dice-neutral-900: #0A0C12;
  --dice-interface-800: #292A34;
  --plinko-history-btn-100: #FFB74C;
  --plinko-history-btn-200: #FF9C2B;
  --plinko-history-btn-300: #FF8800;
  --plinko-history-btn-400: #FE2813;
  --plinko-history-btn-500: #FF0083;
  --plinko-history-btn-600: #8953FC;
  --plinko-history-btn-700: #9603FA;
  --plinko-history-btn-800: #0385FF;
  --plinko-history-btn-900: #04B2AC;
  --primary-surface: #3A236A;
  --gameMineGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
    linear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);
  --diceRangeColor-1: #F1313E;
  --diceRangeColor-2: #3ED179;
  --SkipCardBorder: #B4B4B4;
  --range-slider-primary-bg: #252838;
  --range-slider-secondary-bg: #3C3F4D;
  --bet-history-dice-green: #2CB575;
  --bet-history-dice-red: #303444;
  --tooltip-payout: #D9D9D9;
  --tooltip-payout-date: #686C81;
}

html,
body {
  height: 100%;
  overflow-x: hidden;
  background-color: var(--zinc-950);
}

*::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: var(--zinc-700);
  border-radius: 50em;
}
*::-webkit-scrollbar {
  width: 6px;
  background-color: var(--zinc-700);
  border-radius: 50em;
}
*::-webkit-scrollbar-thumb {
  border-radius: 50em;
  background-color: var(--gray-400);
}

body {
  color: var(--white);
  font-size: 0.938rem;
  font-family: "Inter", sans-serif;
  font-weight: 500;
}
body.dark-theme .rc-tooltip-inner {
  background-color: var(--dice-neutral-300) !important;
  border-color: var(--dice-neutral-300) !important;
  color: var(--black) !important;
}
body.dark-theme .rc-tooltip-arrow {
  border-top-color: var(--dice-neutral-300) !important;
}
body.dark-theme .nav-tabs .nav-item .nav-link.active {
  color: var(--black);
}
body.light-theme .rc-tooltip-inner {
  background-color: var(--TooltipBg) !important;
  border-color: var(--white) !important;
  color: var(--black) !important;
}
body.light-theme .rc-tooltip-arrow {
  border-top-color: var(--white) !important;
}
body.light-theme .nav-tabs .nav-item .nav-link.active {
  color: var(--black);
  background-color: var(--white) !important;
  border-color: var(--white) !important;
}
body #root {
  height: 100%;
}
body .container-fluid {
  padding: 0;
}
body .nav-tabs {
  background-color: var(--gray-800);
  border-radius: 0.375rem;
}
body .nav-tabs .nav-item .nav-link {
  color: #AFAFAF;
  border-radius: 0.25rem;
  font-weight: 400;
}
body .nav-tabs .nav-item .nav-link:hover {
  border-color: transparent;
}
body .nav-tabs .nav-item .nav-link.active {
  background-color: var(--dice-neutral-300);
  border-color: var(--dice-neutral-300);
  color: var(--white);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab {
  color: var(--yellow-700);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(1) .btn-tab.active {
  background-color: var(--yellow-400);
  border-color: var(--yellow-400);
  color: var(--black);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab {
  color: var(--orange-400);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(2) .btn-tab.active {
  background-color: var(--orange-400);
  border-color: var(--orange-400);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab {
  color: var(--red-500);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(3) .btn-tab.active {
  background-color: var(--red-500);
  border-color: var(--red-500);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab {
  color: var(--cyan-400);
}
body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab:is(:hover):enabled:not(.active), body .btn-nav-tabs .btn-nav-tab-items:nth-child(4) .btn-tab.active {
  background-color: var(--cyan-400);
  border-color: var(--cyan-400);
  color: var(--zinc-950);
}
body .btn-nav-tabs .btn-tab {
  background-color: var(--zinc-800);
  border-color: var(--zinc-800);
  color: var(--white);
  padding: 0.25rem 0.25rem;
  font-weight: 500;
  min-width: 48px;
  height: 36px;
  border-radius: 0.25rem;
}
body .btn-nav-tabs .strategy-btn-box .btn-outline-warning:hover,
body .btn-nav-tabs .strategy-btn-box .btn-outline-orange:hover,
body .btn-nav-tabs .strategy-btn-box .btn-outline-danger:hover {
  background-color: var(--zinc-800);
  border-color: var(--zinc-700);
  color: var(--white);
}
body select.form-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right var(--zinc-900);
  -webkit-appearance: none;
  background-position: calc(100% - 12px);
  background-size: 16px;
  padding-right: 35px !important;
}
body .form-control {
  min-height: 44px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: var(--input-ps);
  padding-right: var(--input-pe);
  background-color: var(--dice-neutral-800);
  border-color: var(--dice-neutral-800);
  color: var(--white);
}
body .form-control:focus {
  color: var(--white);
  background-color: var(--dice-neutral-800);
  border-color: var(--zinc-700);
  box-shadow: none;
}
body .form-control:disabled {
  background-color: var(--dice-neutral-800);
  opacity: 0.6;
  cursor: not-allowed;
}
body .custom-input-group .custom-input-group-text {
  gap: 0.375rem;
}
@media screen and (max-width: 767.98px) {
  body .custom-input-group .custom-input-group-text {
    z-index: 0;
  }
}
body .custom-input-group .custom-input-group-text .btn-input-addon {
  background-color: var(--zinc-800);
  border: 1px solid var(--zinc-800);
  color: var(--white);
  height: 36px;
  min-width: 36px;
  padding: 0.125px 0.25rem;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}
body .custom-input-group .custom-input-group-text .btn-input-addon:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
body .custom-input-group .custom-input-group-text .btn-input-addon:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
body .custom-input-group .custom-input-group-text .btn-input-addon:is(:active, :hover):enabled {
  background-color: var(--zinc-700);
  border: 1px solid var(--zinc-700);
}
body .custom-input-group .custom-input-group-text .input-form-control {
  min-height: 30px !important;
  height: 30px !important;
}
body .border-transparent {
  border-color: transparent !important;
}
body .text-gray-400 {
  color: var(--gray-400);
}
body .btn-place-bet {
  font-size: 1rem;
  font-weight: 500;
  min-height: 3.2rem;
}
body button:disabled {
  cursor: not-allowed;
  pointer-events: all;
  opacity: 0.6;
}
body .pointer-events-none {
  pointer-events: none;
}
body .mb-20 {
  margin-bottom: 1.25rem !important;
}
body .rotate-180 {
  transform: rotate(180deg);
}
body .rotate-0 {
  transform: rotate(0deg);
}
body .cursor-pointer {
  cursor: pointer;
}
@media (min-width: 992px) {
  body .g-lg-40,
  body .gx-lg-40 {
    --bs-gutter-x: 2.5rem;
  }
  body .mb-lg-20 {
    margin-bottom: 1.25rem !important;
  }
  body .mb-lg-12 {
    margin-bottom: 0.75rem !important;
  }
}
@media screen and (max-width: 991px) {
  body .rc-tooltip {
    display: none;
  }
}
body .rc-tooltip-inner {
  padding: 6px 6px;
  color: #0B2A23 !important;
  background-color: #47CCA9 !important;
  border-radius: 4px;
  min-height: 28px;
  border: 1px solid #47CCA9 !important;
  font-size: 0.75rem;
  margin-bottom: 0.675rem;
}
body.default .rc-tooltip-inner {
  background-color: #928f98 !important;
  border: 1px solid #928f98 !important;
  color: var(--white) !important;
}
body.default .rc-tooltip-arrow {
  border-top-color: #928f98 !important;
}
body .rc-tooltip-arrow {
  border-top-color: #47CCA9 !important;
  margin-left: 0 !important;
  margin-bottom: 0.675rem;
}
body .crash-history-tooltip {
  opacity: 1;
}
body .crash-history-tooltip .rc-tooltip-inner {
  background-color: var(--dice-neutral-300) !important;
}
body .crash-history-tooltip .rc-tooltip-inner .date-label {
  font-size: 11px;
  color: black;
}
body .crash-history-tooltip .rc-tooltip-inner .payout-label {
  font-size: 11px;
  color: var(--tooltip-payout);
}

@keyframes smooth-slide {
  0% {
    transform: scale(0) translateY(-100%);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes smooth-slide1 {
  0% {
    transform: translateY(-100%);
  }
}
@keyframes smooth-slide2 {
  0% {
    transform: scale(1) translateY(-100%);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes smooth-slide-x {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes smooth-slide-x1 {
  0% {
    transform: translateX(-100%);
  }
}
@keyframes smooth-slide-x2 {
  0% {
    transform: translateX(-100%);
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  transform: scale(0.9);
}

select option {
  color: var(--white);
  background: var(--bgPrimary);
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: transparent !important;
}

.modal .modal-content {
  background-color: var(--gray-90);
  border-radius: 15px;
  color: var(--white);
}
@media screen and (max-width: 575.98px) {
  .modal .modal-content {
    border-radius: 0;
  }
}
.modal .modal-content .modal-body {
  padding: 1.875rem 1.25rem;
}
@media screen and (max-width: 1199.98px) {
  .modal .modal-content .modal-body {
    padding: 1.875rem 1rem 5rem 1rem;
  }
}
.modal .modal-content .btn-close {
  width: 1.5rem;
  max-width: 1.5rem;
  height: 1.5rem;
  background-color: var(--gray-60);
  border: 2px solid var(--gray-90);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  padding: 0;
  position: absolute;
  top: 0.375rem;
  right: 0.25rem;
}
.modal .modal-content .btn-close svg {
  width: 0.625rem;
  height: 0.625rem;
}
.modal .modal-content .heading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  position: relative;
}
.modal .modal-content .heading-wrap .modal-title {
  color: var(--white);
  font-size: 2rem;
  font-weight: 500;
  line-height: 2.75rem;
  text-align: center;
}
.modal .modal-content .body-wrap .body-heading {
  color: var(--white);
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.modal .modal-content .body-wrap .form-group {
  margin-bottom: 1.125rem !important;
}
.modal .modal-content .body-wrap .form-group .form-label {
  color: var(--white);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 0.25rem;
}
.modal .modal-content .body-wrap .form-group .form-label.form-label-grey {
  color: var(--white);
  margin-left: 0.5rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  z-index: 6;
  padding: 0.625rem 0.5rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons img {
  width: 1.25rem;
  max-width: 1.25rem;
  max-height: 1.25rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn {
  height: 1.875rem;
  background-color: var(--game-color-400);
  border: 0;
  border-radius: 0.313rem;
  color: var(--game-text-100);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.375rem 0.625rem;
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--game-text-100);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn svg path {
  fill: var(--game-text-100);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn:hover, .modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn.active {
  background-color: var(--game-primary);
  color: var(--white);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn:hover svg, .modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn.active svg {
  fill: var(--white);
}
.modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn:hover svg path, .modal .modal-content .body-wrap .form-group .custom-input-group-addons .input-btn.active svg path {
  fill: var(--white);
}
.modal .modal-content .body-wrap .form-group .input-group {
  position: relative;
}
.modal .modal-content .body-wrap .form-group .input-group .form-control {
  width: 100%;
  height: 3.25rem;
  background-color: var(--game-color-300);
  border: 1px solid var(--game-border-200);
  border-radius: 0.375rem;
  color: var(--game-text-100);
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0.625rem 0.75rem;
  margin: 0;
}
.modal .modal-content .body-wrap .btn-box {
  display: flex;
  flex-direction: column;
  gap: 0.938rem;
  margin-top: 0.313rem;
}
.modal .modal-content .body-wrap .btn-box .btn {
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.125rem;
  padding: 1rem;
}
.modal .modal-content .body-wrap .btn-box .btn-place-bet {
  background-color: var(--game-primary);
  border: 2px solid var(--game-primary);
  color: var(--white);
}
.modal .modal-content .body-wrap .btn-box .btn-place-bet-outline {
  background-color: transparent;
  border: 2px solid var(--game-border-300);
  color: var(--game-text-100);
}
.modal .modal-content .body-wrap .btn-box .btn-text {
  background-color: transparent;
  border: 0;
  color: var(--white);
}
.modal .modal-content .body-wrap ol li {
  font-size: 0.875rem;
}
.modal .modal-content .body-wrap ol li:not(:last-child) {
  margin-bottom: 0.125rem;
}
.modal .modal-content .body-wrap ol li.game-rules-text {
  color: var(--game-text-100);
}
.modal .modal-content .body-wrap hr {
  background-color: var(--game-border-100);
  opacity: 1;
  margin: 1rem 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_variables.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EAEE,oBAAA;EACA,gBAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,mCAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,0BAAA;EAGA,6NAAA;EACA,2QAAA;EACA,sIAAA;EACA,4FAAA;EAIA,sBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kCAAA;EAEA,gBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EAGA,uCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,0CAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,uCAAA;EACA,uCAAA;EACA,yCAAA;EACA,sCAAA;EACA,oBAAA;EAEA,0BAAA;EACA,2BAAA;EAEA,iGAAA;EACA,0GAAA;EACA;2EAAA;EAIA,uKAAA;EACA,wIAAA;EAEA,oGAAA;EAEA,mBAAA;EACA,mBAAA;EAGA,4BAAA;EACA,2BAAA;EACA,8CAAA;EAEA,0BAAA;EAEA,0CAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,wBAAA;EAEA,yBAAA;EAEA,2BAAA;EAEA,0CAAA;EACA,4BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EAGA,6BAAA;EAEA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EAEA,0BAAA;EAEA;8GAAA;EAKA,kCAAA;EACA,oCAAA;EAEA,6DAAA;EACA,mEAAA;EACA,0BAAA;EACA,oBAAA;EACA,4BAAA;EAEA,2BAAA;EACA,2BAAA;EAGA,iCAAA;EACA,+BAAA;EAEA,yBAAA;EACA,8BAAA;AC5CF;;ADiDA;EACE,mBAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,oBAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,6BAAA;EAGA,kCAAA;EACA,oCAAA;EAEA,iCAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,yBAAA;AClDF;;ADqDA;EACE,wBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,iBAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,2BAAA;EAEA,kCAAA;EACA,oCAAA;EAEA,iCAAA;EACA,+BAAA;EACA,yBAAA;ACrDF;;ADyDA;EACE,oBAAA;EACA,gBAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,mCAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,0BAAA;EAGA,6NAAA;EACA,2QAAA;EACA,sIAAA;EACA,4FAAA;EAIA,sBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kCAAA;EAEA,gBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EAGA,uCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,0CAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,uCAAA;EACA,uCAAA;EACA,yCAAA;EACA,sCAAA;EACA,oBAAA;EAEA,0BAAA;EACA,2BAAA;EAEA,iGAAA;EACA,0GAAA;EACA;2EAAA;EAIA,uKAAA;EACA,wIAAA;EAEA,oGAAA;EAEA,mBAAA;EACA,mBAAA;EAGA,4BAAA;EACA,2BAAA;EACA,8CAAA;EAEA,0BAAA;EAEA,0CAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,wBAAA;EAEA,yBAAA;EAEA,2BAAA;EAEA,0CAAA;EACA,4BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EAGA,6BAAA;EAEA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EAEA,0BAAA;EAEA;8GAAA;EAGA,2BAAA;EACA,2BAAA;EACA,yBAAA;EAEA,kCAAA;EACA,oCAAA;EAEA,iCAAA;EACA,+BAAA;EACA,yBAAA;EACA,8BAAA;AC7FF;;AA7WA;;EAEE,YAAA;EACA,kBAAA;EACA,iCAAA;AAgXF;;AA3WE;EACE,oDAAA;EACA,iCAAA;EACA,mBAAA;AA8WJ;AA3WE;EACE,UAAA;EACA,iCAAA;EACA,mBAAA;AA6WJ;AA1WE;EACE,mBAAA;EACA,iCAAA;AA4WJ;;AAxWA;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;AA2WF;AAxWI;EACE,oDAAA;EACA,gDAAA;EACA,8BAAA;AA0WN;AAvWI;EACE,oDAAA;AAyWN;AAnWU;EACE,mBAAA;AAqWZ;AA7VI;EACE,6CAAA;EACA,qCAAA;EACA,8BAAA;AA+VN;AA5VI;EACE,yCAAA;AA8VN;AAxVU;EACE,mBAAA;EACA,yCAAA;EACA,qCAAA;AA0VZ;AAnVE;EACE,YAAA;AAqVJ;AAlVE;EACE,UAAA;AAoVJ;AAjVE;EACE,iCAAA;EACA,uBAAA;AAmVJ;AAhVM;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;AAkVR;AAhVQ;EACE,yBAAA;AAkVV;AA/UQ;EACE,yCAAA;EACA,qCAAA;EACA,mBAAA;AAiVV;AA1UI;EACE,wBAAA;AA4UN;AA1UM;EAEE,mCAAA;EACA,+BAAA;EACA,mBAAA;AA2UR;AAvUI;EACE,wBAAA;AAyUN;AAvUM;EAEE,mCAAA;EACA,+BAAA;EACA,sBAAA;AAwUR;AApUI;EACE,qBAAA;AAsUN;AApUM;EAEE,gCAAA;EACA,4BAAA;EACA,sBAAA;AAqUR;AAjUI;EACE,sBAAA;AAmUN;AAjUM;EAEE,iCAAA;EACA,6BAAA;EACA,sBAAA;AAkUR;AA9TI;EACE,iCAAA;EACA,6BAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAgUN;AA3TM;;;EAGE,iCAAA;EACA,6BAAA;EACA,mBAAA;AA6TR;AAtTI;EACE,mFAAA;EACA,wBAAA;EACA,sCAAA;EACA,qBAAA;EACA,8BAAA;AAwTN;AApTE;EACE,gBAAA;EACA,oBAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;EACA,yCAAA;EACA,qCAAA;EACA,mBAAA;AAsTJ;AApTI;EACE,mBAAA;EACA,yCAAA;EACA,6BAAA;EACA,gBAAA;AAsTN;AAnTI;EACE,yCAAA;EACA,YAAA;EACA,mBAAA;AAqTN;AAhTI;EACE,aAAA;AAkTN;AAhTM;EAHF;IAII,UAAA;EAmTN;AACF;AAjTM;EACE,iCAAA;EACA,iCAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAmTR;AAjTQ;EACE,0BAAA;EACA,6BAAA;AAmTV;AAhTQ;EACE,yBAAA;EACA,4BAAA;AAkTV;AA/SQ;EACE,iCAAA;EACA,iCAAA;AAiTV;AA7SM;EACE,2BAAA;EACA,uBAAA;AA+SR;AA1SE;EACE,oCAAA;AA4SJ;AAzSE;EACE,sBAAA;AA2SJ;AAxSE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA0SJ;AAtSI;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAwSN;AApSE;EACE,oBAAA;AAsSJ;AAnSE;EACE,iCAAA;AAqSJ;AAlSE;EACE,yBAAA;AAoSJ;AAjSE;EACE,uBAAA;AAmSJ;AAhSE;EACE,eAAA;AAkSJ;AA/RE;EAEE;;IAEE,qBAAA;EAgSJ;EA7RE;IACE,iCAAA;EA+RJ;EA5RE;IACE,iCAAA;EA8RJ;AACF;AA3RE;EACE;IACE,aAAA;EA6RJ;AACF;AA1RE;EACE,gBAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,uBAAA;AA4RJ;AAxRI;EACE,oCAAA;EACA,oCAAA;EACA,8BAAA;AA0RN;AAvRI;EACE,oCAAA;AAyRN;AArRE;EACE,oCAAA;EACA,yBAAA;EACA,uBAAA;AAuRJ;AApRE;EACE,UAAA;AAsRJ;AApRI;EACE,oDAAA;AAsRN;AApRM;EACE,eAAA;EAEA,YAAA;AAqRR;AAlRM;EACE,eAAA;EACA,4BAAA;AAoRR;;AA9QA;EACE;IACE,qCAAA;EAiRF;EA9QA;IACE,mBAAA;EAgRF;AACF;AA7QA;EACE;IACE,4BAAA;EA+QF;AACF;AA5QA;EACE;IACE,qCAAA;EA8QF;EA3QA;IACE,mBAAA;EA6QF;AACF;AA1QA;EACE;IACE,mBAAA;EA4QF;EAzQA;IACE,mBAAA;EA2QF;AACF;AAxQA;EACE;IACE,4BAAA;EA0QF;AACF;AAvQA;EACE;IACE,4BAAA;EAyQF;AACF;AArQA,gCAAA;AACA;;EAEE,qBAAA;AAuQF;;AApQA;EACE,mBAAA;EACA,4BAAA;AAuQF;;AApQA;EACE,kCAAA;AAuQF;;AApQA;EACE,gCAAA;EACA,mBAAA;EACA,mBAAA;AAuQF;AArQE;EALF;IAMI,gBAAA;EAwQF;AACF;AAtQE;EACE,yBAAA;AAwQJ;AAtQI;EAHF;IAII,gCAAA;EAyQJ;AACF;AAtQE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAwQJ;AAtQI;EACE,eAAA;EACA,gBAAA;AAwQN;AApQE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAsQJ;AApQI;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAsQN;AAjQI;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAmQN;AAhQI;EACE,kCAAA;AAkQN;AAhQM;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAkQR;AAhQQ;EACE,mBAAA;EACA,mBAAA;AAkQV;AA9PM;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,wBAAA;AAgQR;AA9PQ;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AAgQV;AA7PQ;EACE,gBAAA;EACA,uCAAA;EACA,SAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AA+PV;AA7PU;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AA+PZ;AA7PY;EACE,0BAAA;AA+Pd;AA3PU;EAEE,qCAAA;EACA,mBAAA;AA4PZ;AA1PY;EACE,kBAAA;AA4Pd;AA1Pc;EACE,kBAAA;AA4PhB;AArPM;EACE,kBAAA;AAuPR;AArPQ;EACE,WAAA;EACA,eAAA;EACA,uCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;AAuPV;AAlPI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;AAoPN;AAlPM;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;AAoPR;AAjPM;EACE,qCAAA;EACA,qCAAA;EACA,mBAAA;AAmPR;AAhPM;EACE,6BAAA;EACA,wCAAA;EACA,2BAAA;AAkPR;AA/OM;EACE,6BAAA;EACA,SAAA;EACA,mBAAA;AAiPR;AA5OM;EACE,mBAAA;AA8OR;AA5OQ;EACE,uBAAA;AA8OV;AA3OQ;EACE,2BAAA;AA6OV;AAxOI;EACE,wCAAA;EACA,UAAA;EACA,cAAA;AA0ON","sourcesContent":[":root {\n  // colors variables\n  --white-100: #EDEDF0;\n  --white: #ffffff;\n  --white-1: rgba(255, 255, 255, 0.1);\n  --white-02: rgba(255, 255, 255, 0.02);\n  --white-4: rgba(255, 255, 255, 0.4);\n  --white-5: rgba(255, 255, 255, 0.5);\n  --white-08: rgba(255, 255, 255, 0.08);\n  --white-6: #EDEDF0;\n  --black: #000000;\n  --black-900: #050505;\n  --textBlack: #393838;\n  --black-25: rgba(0, 0, 0, 0.25);\n  --black-35: rgb(0, 0, 0, 0.35);\n  --btnText: rgb(111 60 0 / 81%);\n  --darkText: #393838;\n  --bgPrimary: #1C1C1C;\n  --primaryBtn: #FFE500;\n  --historyYellow: #453F02;\n  --historyRed: #450A0A;\n  --historyRedText: #F87171;\n  --historyBlue: #172554;\n  --historyBlueText: #60A5FA;\n  --historyGreen: #022C22;\n  --historyGreenText: #10B981;\n  --historyGray: #222223;\n  --historyGrayText: #A1A1AA;\n\n  // gradient variables\n  --gameSidebarBg: linear-gradient(91.76deg, rgba(32, 30, 30, 1) 0%, rgba(32, 30, 30, 1) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.02) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);\n  --gameInputBg: linear-gradient(91.76deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.35) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.06) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);\n  --gameContainerOverlay: linear-gradient(91.76deg, rgba(32, 30, 30, 0.9) 0%, rgba(32, 30, 30, 0.75) 53.12%, rgba(32, 30, 30, 0.9) 100%);\n  --gameNumbersSaperatorBg: linear-gradient(270deg, #FFE500 0%, rgba(254, 224, 64, 0.25) 100%);\n\n  // new variable\n\n  --primary-300: #928403;\n  --primary-600: #FFD600;\n\n  --zinc-600: #52525B;\n  --zinc-650: #4C4C52;\n  --zinc-700: #3F3F46;\n  --zinc-800: #27272A;\n  --zinc-850: #333333;\n  --zinc-900: #18181B;\n  --zinc-950: #09090B;\n  --zinc-950-06: rgba(9, 9, 11, 0.6);\n  --zinc-950-07: rgba(9, 9, 11, 0.7);\n\n  --black: #000000;\n  --black-20: #00000033;\n  --black-30: rgb(0 0 0 / 30%);\n\n  --gray-100-21: rgba(79, 79, 79, 0.21);\n  --gray-200: #696969;\n  --gray-300: #B8B8B8;\n  --gray-400: #949494;\n  --gray-700: #3D3D43;\n  --gray-750: #272727;\n  --gray-800: #10473A;\n  --gray-850-32: rgba(35, 35, 35, 0.32);\n  --gray-850: #2A2A31;\n  --gray-900: #191A1E;\n  --gray-950: #232323;\n  --gray-900-15: rgb(126 126 126 / 21%);\n  --gray-975: #040404;\n\n  // history colors variables\n  --yellow-200-04: rgba(255, 230, 0, 0.4);\n  --yellow-200-20: rgba(255, 229, 0, 0.20);\n  --yellow-200-24: rgba(255, 230, 0, 0.24);\n  --yellow-200-30: rgba(255, 229, 0, 0.30);\n  --yellow-200-54: rgba(255, 230, 0, 0.54);\n  --yellow-300-60: rgba(255, 230, 117, 0.60);\n  --yellow-200-61: rgba(255, 222, 82, 0.61);\n  --yellow-400: #F6D76B;\n  --yellow-500: #F6C36B;\n  --yellow-600: #FFE353;\n  --yellow-700: #FFE500;\n  --yellow-800: #EBC500;\n  --yellow-900: #443D00;\n\n  --pink-300: #FE6969;\n  --pink-400: #E7635E;\n  --pink-600: #E34A5C;\n\n  --orange-300: #F0A265;\n  --orange-350: #F39946;\n  --orange-400: #F4754D;\n  --orange-500: #FF5C00;\n  --orange-900: #44190C;\n\n  --red-100: #F1313E;\n  --red-500: #EF4444;\n  --red-500-2: rgba(239, 68, 68, 0.2);\n  --red-600: #F80027;\n  --red-900: #200000;\n\n  --cyan-400: #7EFFF0;\n  --cyan-900: #02312C;\n\n  --purple-100-08: rgba(179, 19, 255, 0.08);\n  --purple-100-30: rgba(179, 19, 255, 0.30);\n  --purple-200: #0689FF;\n  --purple-400: #8000FF;\n  --purple-500: #B313FF;\n  --purple-600-04: rgba(98, 1, 255, 0.4);\n  --purple-600-54: rgba(98, 1, 255, 0.54);\n  --purple-600-24: rgba(98, 1, 255, 0.24);\n  --purple-600-66: rgba(129, 59, 242, 0.66);\n  --purple-600-04: rgba(98, 1, 255, 0.4);\n  --green-400: #3ED179;\n\n  --gameContainerBg: #10473A;\n  --btn-grey-primary: #252838;\n\n  --purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);\n  --purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);\n  --purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),\n    radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);\n\n\n  --plinkoBgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);\n  --plinkoSidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);\n\n  --primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;\n\n  --input-ps: 0.75rem;\n  --input-pe: 0.75rem;\n\n  // dest new var\n  --dice-primary-main: #8953FC;\n  --dice-primary-800: #F57F31;\n  --dice-primary-main-2: rgba(137, 83, 252, 0.2);\n\n  --dice-green-main: #2CB575;\n\n  --dice-dark-700-75: rgba(10, 12, 18, 0.75);\n\n  --dice-grey-100: #D9D9D9;\n  --dice-grey-200: #B4B6C1;\n  --dice-grey-300: #9598A7;\n  --dice-grey-400: #686C81;\n\n  --dice-red-main: #B52C2C;\n\n  --dice-high-blue: #349DD9;\n\n  --dice-orange-main: #FF8800;\n\n  --dice-blue-focus-2: rgba(0, 92, 230, 0.2);\n  --dice-blue-pressed: #0040A1;\n\n  --dice-neutral-100: #303444;\n  --dice-neutral-200: #333748;\n  --dice-neutral-300: #246D5A;\n  --dice-neutral-400: #1E212F;\n  --dice-neutral-500: #10473A;\n  --dice-neutral-600: #0B2A23;\n  --dice-neutral-700: #0F3930;\n  --dice-neutral-800: #0D0F15;\n  --dice-neutral-900: #0A0C12;\n\n\n  --dice-interface-800: #292A34;\n\n  --plinko-history-btn-100: #FFB74C;\n  --plinko-history-btn-200: #FF9C2B;\n  --plinko-history-btn-300: #FF8800;\n  --plinko-history-btn-400: #FE2813;\n  --plinko-history-btn-500: #FF0083;\n  --plinko-history-btn-600: #8953FC;\n  --plinko-history-btn-700: #9603FA;\n  --plinko-history-btn-800: #0385FF;\n  --plinko-history-btn-900: #04B2AC;\n\n  --primary-surface: #3A236A;\n\n  --gameMineGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n    linear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);\n\n  // hilo game\n\n  --range-slider-primary-bg: #246D5A;\n  --range-slider-secondary-bg: #10473A;\n\n  --hilo-btn: linear-gradient(180deg, #03A5D9 0%, #03789D 100%);\n  --hilo-btn-hover: linear-gradient(180deg, #03789D 0%, #03A5D9 100%);\n  --hilo-tile-hover: #494E67;\n  --hilo-card: #8F8F8F;\n  --hilo-card-hover: #000000B2;\n\n  --diceRangeColor-1: #B6C649;\n  --diceRangeColor-2: #F57F31;\n\n  // green means success, red means\n  --bet-history-dice-green: #B6C649;\n  --bet-history-dice-red: #246D5A;\n\n  --tooltip-payout: #D9D9D9;\n  --tooltip-payout-date: #246D5A;\n}\n\n\n\n.dark-theme {\n  --gray-800: #202022;\n  --dice-neutral-700: #101010;\n  --dice-primary-800: #FECB46;\n  --dice-neutral-300: #F1C24C;\n  --white: #fff;\n  --white-100: #9598A7;\n  --dice-neutral-600: #171717;\n  --dice-neutral-800: #202022;\n  --gameContainerBg: #202022;\n  --neutral-300: #292C39;\n  --configModal: #1E212F;\n  --dice-neutral-500: #202022;\n  --riskActiveBbtn: #FEEBB9;\n  --multiplier-100: #5C91BC;\n  --multiplier-200: #8F52BF;\n  --multiplier-300: #CC9B5A;\n  --multiplier-400: #BC5550;\n  --hilo-card-multiply: #212121;\n\n\n  --range-slider-primary-bg: #F1C24C;\n  --range-slider-secondary-bg: #202022;\n\n  --bet-history-dice-green: #F1C24C;\n  --bet-history-dice-red: #171717;\n\n  --diceRangeColor-2: #FED569;\n  --diceRangeColor-1: #8C6A26;\n  --tooltip-payout: #171717;\n}\n\n.light-theme {\n  --dice-neutral-700: #000;\n  --gameContainerBg: #fff;\n  --gray-800: #000;\n  --dice-neutral-300: #48F4FF;\n  --dice-neutral-600: #3D3D3D;\n  --livestate-li: #1e1e1e;\n  --input-arrow-icon: #686C81;\n  --input-multiplier: #3D3D3D;\n  --border: #292C39;\n  --configure-modal-bg: #0A0A0A;\n  --configure-modal-btn: #48F4FF;\n  --configure-modal-bottom: #171717;\n  --footer-svg: #8E8E8E;\n  --riskBtnColor: #202022;\n  --TooltipBg: #D2D2D2;\n  --DiceBgColor: #151515;\n  --DiceGameBorder: #855BFC;\n  --SkipCardBorder: #B4B4B4;\n\n  --diceRangeColor-1: #48F4FF;\n  --diceRangeColor-2: #855BFC;\n\n  --range-slider-primary-bg: #48F4FF;\n  --range-slider-secondary-bg: #202022;\n\n  --bet-history-dice-green: #48F4FF;\n  --bet-history-dice-red: #1E1E1E;\n  --tooltip-payout: #171717;\n}\n\n\n.default {\n  --white-100: #EDEDF0;\n  --white: #ffffff;\n  --white-1: rgba(255, 255, 255, 0.1);\n  --white-02: rgba(255, 255, 255, 0.02);\n  --white-4: rgba(255, 255, 255, 0.4);\n  --white-5: rgba(255, 255, 255, 0.5);\n  --white-08: rgba(255, 255, 255, 0.08);\n  --white-6: #EDEDF0;\n  --black: #000000;\n  --black-900: #050505;\n  --textBlack: #393838;\n  --black-25: rgba(0, 0, 0, 0.25);\n  --black-35: rgb(0, 0, 0, 0.35);\n  --btnText: rgb(111 60 0 / 81%);\n  --darkText: #393838;\n  --bgPrimary: #1C1C1C;\n  --primaryBtn: #FFE500;\n  --historyYellow: #453F02;\n  --historyRed: #450A0A;\n  --historyRedText: #F87171;\n  --historyBlue: #172554;\n  --historyBlueText: #60A5FA;\n  --historyGreen: #022C22;\n  --historyGreenText: #10B981;\n  --historyGray: #222223;\n  --historyGrayText: #A1A1AA;\n\n  // gradient variables\n  --gameSidebarBg: linear-gradient(91.76deg, rgba(32, 30, 30, 1) 0%, rgba(32, 30, 30, 1) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.02) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);\n  --gameInputBg: linear-gradient(91.76deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.35) 100%), linear-gradient(91.18deg, rgba(255, 255, 255, 0.16) -0.95%, rgba(255, 255, 255, 0.06) 48.96%, rgba(255, 255, 255, 0.15) 106.7%);\n  --gameContainerOverlay: linear-gradient(91.76deg, rgba(32, 30, 30, 0.9) 0%, rgba(32, 30, 30, 0.75) 53.12%, rgba(32, 30, 30, 0.9) 100%);\n  --gameNumbersSaperatorBg: linear-gradient(270deg, #FFE500 0%, rgba(254, 224, 64, 0.25) 100%);\n\n  // new variable\n\n  --primary-300: #928403;\n  --primary-600: #FFD600;\n\n  --zinc-600: #52525B;\n  --zinc-650: #4C4C52;\n  --zinc-700: #3F3F46;\n  --zinc-800: #27272A;\n  --zinc-850: #333333;\n  --zinc-900: #18181B;\n  --zinc-950: #09090B;\n  --zinc-950-06: rgba(9, 9, 11, 0.6);\n  --zinc-950-07: rgba(9, 9, 11, 0.7);\n\n  --black: #000000;\n  --black-20: #00000033;\n  --black-30: rgb(0 0 0 / 30%);\n\n  --gray-100-21: rgba(79, 79, 79, 0.21);\n  --gray-200: #696969;\n  --gray-300: #B8B8B8;\n  --gray-400: #949494;\n  --gray-700: #3D3D43;\n  --gray-750: #272727;\n  --gray-800: #1A1C28;\n  --gray-850-32: rgba(35, 35, 35, 0.32);\n  --gray-850: #2A2A31;\n  --gray-900: #191A1E;\n  --gray-950: #232323;\n  --gray-900-15: rgb(126 126 126 / 21%);\n  --gray-975: #040404;\n\n  // history colors variables\n  --yellow-200-04: rgba(255, 230, 0, 0.4);\n  --yellow-200-20: rgba(255, 229, 0, 0.20);\n  --yellow-200-24: rgba(255, 230, 0, 0.24);\n  --yellow-200-30: rgba(255, 229, 0, 0.30);\n  --yellow-200-54: rgba(255, 230, 0, 0.54);\n  --yellow-300-60: rgba(255, 230, 117, 0.60);\n  --yellow-200-61: rgba(255, 222, 82, 0.61);\n  --yellow-400: #F6D76B;\n  --yellow-500: #F6C36B;\n  --yellow-600: #FFE353;\n  --yellow-700: #FFE500;\n  --yellow-800: #EBC500;\n  --yellow-900: #443D00;\n\n  --pink-300: #FE6969;\n  --pink-400: #E7635E;\n  --pink-600: #E34A5C;\n\n  --orange-300: #F0A265;\n  --orange-350: #F39946;\n  --orange-400: #F4754D;\n  --orange-500: #FF5C00;\n  --orange-900: #44190C;\n\n  --red-500: #EF4444;\n  --red-500-2: rgba(239, 68, 68, 0.2);\n  --red-600: #F80027;\n  --red-900: #200000;\n\n  --cyan-400: #7EFFF0;\n  --cyan-900: #02312C;\n\n  --purple-100-08: rgba(179, 19, 255, 0.08);\n  --purple-100-30: rgba(179, 19, 255, 0.30);\n  --purple-200: #0689FF;\n  --purple-400: #8000FF;\n  --purple-500: #B313FF;\n  --purple-600-04: rgba(98, 1, 255, 0.4);\n  --purple-600-54: rgba(98, 1, 255, 0.54);\n  --purple-600-24: rgba(98, 1, 255, 0.24);\n  --purple-600-66: rgba(129, 59, 242, 0.66);\n  --purple-600-04: rgba(98, 1, 255, 0.4);\n  --green-400: #3ED179;\n\n  --gameContainerBg: #1B1E2E;\n  --btn-grey-primary: #252838;\n\n  --purpleYellowRadialGradient: radial-gradient(76.67% 76.67% at 50% 50%, #FFE600 0%, #B947FF 100%);\n  --purpleYellowRadialGradientHover: radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 44.27%, #B947FF 100%);\n  --purpleYellowRadialGradientActive: linear-gradient(0deg, rgba(255, 229, 0, 0.3), rgba(255, 229, 0, 0.3)),\n    radial-gradient(68.33% 68.33% at 50% 50%, #FFE600 22.92%, #B947FF 100%);\n\n\n  --plinkoBgGradient: linear-gradient(0deg, rgba(255, 77, 38, 0.40) 0%, rgba(255, 135, 24, 0.25) 7.29%, rgba(255, 229, 0, 0.00) 70.31%, rgba(255, 255, 255, 0.00) 94.27%);\n  --plinkoSidebarGradient: linear-gradient(0deg, rgba(7, 77, 198, 0.40) 0%, rgba(125, 33, 131, 0.40) 8.85%, rgba(35, 35, 35, 0.32) 94.27%);\n\n  --primaryBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #D08732 inset;\n\n  --input-ps: 0.75rem;\n  --input-pe: 0.75rem;\n\n  // dest new var\n  --dice-primary-main: #8953FC;\n  --dice-primary-800: #6238BB;\n  --dice-primary-main-2: rgba(137, 83, 252, 0.2);\n\n  --dice-green-main: #2CB575;\n\n  --dice-dark-700-75: rgba(10, 12, 18, 0.75);\n\n  --dice-grey-100: #D9D9D9;\n  --dice-grey-200: #B4B6C1;\n  --dice-grey-300: #9598A7;\n  --dice-grey-400: #686C81;\n\n  --dice-red-main: #B52C2C;\n\n  --dice-high-blue: #349DD9;\n\n  --dice-orange-main: #FF8800;\n\n  --dice-blue-focus-2: rgba(0, 92, 230, 0.2);\n  --dice-blue-pressed: #0040A1;\n\n  --dice-neutral-100: #303444;\n  --dice-neutral-200: #333748;\n  --dice-neutral-300: #292C39;\n  --dice-neutral-400: #1E212F;\n  --dice-neutral-500: #1A1C28;\n  --dice-neutral-600: #151721;\n  --dice-neutral-700: #11131B;\n  --dice-neutral-800: #0D0F15;\n  --dice-neutral-900: #0A0C12;\n\n\n  --dice-interface-800: #292A34;\n\n  --plinko-history-btn-100: #FFB74C;\n  --plinko-history-btn-200: #FF9C2B;\n  --plinko-history-btn-300: #FF8800;\n  --plinko-history-btn-400: #FE2813;\n  --plinko-history-btn-500: #FF0083;\n  --plinko-history-btn-600: #8953FC;\n  --plinko-history-btn-700: #9603FA;\n  --plinko-history-btn-800: #0385FF;\n  --plinko-history-btn-900: #04B2AC;\n\n  --primary-surface: #3A236A;\n\n  --gameMineGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n    linear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);\n\n  --diceRangeColor-1: #F1313E;\n  --diceRangeColor-2: #3ED179;\n  --SkipCardBorder: #B4B4B4;\n\n  --range-slider-primary-bg: #252838;\n  --range-slider-secondary-bg: #3C3F4D;\n\n  --bet-history-dice-green: #2CB575;\n  --bet-history-dice-red: #303444;\n  --tooltip-payout: #D9D9D9;\n  --tooltip-payout-date: #686C81;\n}\n","@import './assets/scss/variables';\n\nhtml,\nbody {\n  height: 100%;\n  overflow-x: hidden;\n  background-color: var(--zinc-950);\n}\n\n\n* {\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: var(--zinc-700);\n    border-radius: 50em;\n  }\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    background-color: var(--zinc-700);\n    border-radius: 50em;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 50em;\n    background-color: var(--gray-400);\n  }\n}\n\nbody {\n  color: var(--white);\n  font-size: 0.938rem;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n\n  &.dark-theme {\n    .rc-tooltip-inner {\n      background-color: var(--dice-neutral-300) !important;\n      border-color: var(--dice-neutral-300) !important;\n      color: var(--black) !important;\n    }\n\n    .rc-tooltip-arrow {\n      border-top-color: var(--dice-neutral-300) !important;\n    }\n\n    .nav-tabs {\n      .nav-item {\n        .nav-link {\n          &.active {\n            color: var(--black);\n          }\n        }\n      }\n    }\n  }\n\n  &.light-theme {\n    .rc-tooltip-inner {\n      background-color: var(--TooltipBg) !important;\n      border-color: var(--white) !important;\n      color: var(--black) !important;\n    }\n\n    .rc-tooltip-arrow {\n      border-top-color: var(--white) !important;\n    }\n\n    .nav-tabs {\n      .nav-item {\n        .nav-link {\n          &.active {\n            color: var(--black);\n            background-color: var(--white) !important;\n            border-color: var(--white) !important;\n          }\n        }\n      }\n    }\n  }\n\n  #root {\n    height: 100%;\n  }\n\n  .container-fluid {\n    padding: 0;\n  }\n\n  .nav-tabs {\n    background-color: var(--gray-800);\n    border-radius: 0.375rem;\n\n    .nav-item {\n      .nav-link {\n        color: #AFAFAF;\n        border-radius: 0.25rem;\n        font-weight: 400;\n\n        &:hover {\n          border-color: transparent;\n        }\n\n        &.active {\n          background-color: var(--dice-neutral-300);\n          border-color: var(--dice-neutral-300);\n          color: var(--white);\n        }\n      }\n    }\n  }\n\n  .btn-nav-tabs {\n    .btn-nav-tab-items:nth-child(1) .btn-tab {\n      color: var(--yellow-700);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--yellow-400);\n        border-color: var(--yellow-400);\n        color: var(--black);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(2) .btn-tab {\n      color: var(--orange-400);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--orange-400);\n        border-color: var(--orange-400);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(3) .btn-tab {\n      color: var(--red-500);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--red-500);\n        border-color: var(--red-500);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-nav-tab-items:nth-child(4) .btn-tab {\n      color: var(--cyan-400);\n\n      &:is(:hover):enabled:not(.active),\n      &.active {\n        background-color: var(--cyan-400);\n        border-color: var(--cyan-400);\n        color: var(--zinc-950);\n      }\n    }\n\n    .btn-tab {\n      background-color: var(--zinc-800);\n      border-color: var(--zinc-800);\n      color: var(--white);\n      padding: 0.25rem 0.25rem;\n      font-weight: 500;\n      min-width: 48px;\n      height: 36px;\n      border-radius: 0.25rem;\n    }\n\n    .strategy-btn-box {\n\n      .btn-outline-warning:hover,\n      .btn-outline-orange:hover,\n      .btn-outline-danger:hover {\n        background-color: var(--zinc-800);\n        border-color: var(--zinc-700);\n        color: var(--white);\n      }\n    }\n\n  }\n\n  select {\n    &.form-control {\n      background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\") no-repeat right var(--zinc-900);\n      -webkit-appearance: none;\n      background-position: calc(100% - 12px);\n      background-size: 16px;\n      padding-right: 35px !important;\n    }\n  }\n\n  .form-control {\n    min-height: 44px;\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n    padding-left: var(--input-ps);\n    padding-right: var(--input-pe);\n    background-color: var(--dice-neutral-800);\n    border-color: var(--dice-neutral-800);\n    color: var(--white);\n\n    &:focus {\n      color: var(--white);\n      background-color: var(--dice-neutral-800);\n      border-color: var(--zinc-700);\n      box-shadow: none;\n    }\n\n    &:disabled {\n      background-color: var(--dice-neutral-800);\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  .custom-input-group {\n    .custom-input-group-text {\n      gap: 0.375rem;\n\n      @media screen and (max-width: 767.98px) {\n        z-index: 0;\n      }\n\n      .btn-input-addon {\n        background-color: var(--zinc-800);\n        border: 1px solid var(--zinc-800);\n        color: var(--white);\n        height: 36px;\n        min-width: 36px;\n        padding: 0.125px 0.25rem;\n        font-weight: 500;\n        font-size: 0.875rem;\n        border-radius: .25rem;\n\n        &:not(:last-child) {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n\n        &:not(:first-child) {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n\n        &:is(:active, :hover):enabled {\n          background-color: var(--zinc-700);\n          border: 1px solid var(--zinc-700);\n        }\n      }\n\n      .input-form-control {\n        min-height: 30px !important;\n        height: 30px !important;\n      }\n    }\n  }\n\n  .border-transparent {\n    border-color: transparent !important;\n  }\n\n  .text-gray-400 {\n    color: var(--gray-400);\n  }\n\n  .btn-place-bet {\n    font-size: 1rem;\n    font-weight: 500;\n    min-height: 3.2rem;\n  }\n\n  button {\n    &:disabled {\n      cursor: not-allowed;\n      pointer-events: all;\n      opacity: 0.6;\n    }\n  }\n\n  .pointer-events-none {\n    pointer-events: none;\n  }\n\n  .mb-20 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .rotate-180 {\n    transform: rotate(180deg);\n  }\n\n  .rotate-0 {\n    transform: rotate(0deg);\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n  }\n\n  @media (min-width: 992px) {\n\n    .g-lg-40,\n    .gx-lg-40 {\n      --bs-gutter-x: 2.5rem;\n    }\n\n    .mb-lg-20 {\n      margin-bottom: 1.25rem !important;\n    }\n\n    .mb-lg-12 {\n      margin-bottom: 0.75rem !important;\n    }\n  }\n\n  @media screen and (max-width: 991px) {\n    .rc-tooltip {\n      display: none;\n    }\n  }\n\n  .rc-tooltip-inner {\n    padding: 6px 6px;\n    color: #0B2A23 !important;\n    background-color: #47CCA9 !important;\n    border-radius: 4px;\n    min-height: 28px;\n    border: 1px solid #47CCA9 !important;\n    font-size: 0.75rem;\n    margin-bottom: 0.675rem;\n  }\n\n  &.default {\n    .rc-tooltip-inner {\n      background-color: #928f98 !important;\n      border: 1px solid #928f98 !important;\n      color: var(--white) !important;\n    }\n\n    .rc-tooltip-arrow {\n      border-top-color: #928f98 !important;\n    }\n  }\n\n  .rc-tooltip-arrow {\n    border-top-color: #47CCA9 !important;\n    margin-left: 0 !important;\n    margin-bottom: 0.675rem;\n  }\n\n  .crash-history-tooltip {\n    opacity: 1;\n\n    .rc-tooltip-inner {\n      background-color: var(--dice-neutral-300) !important;\n\n      .date-label {\n        font-size: 11px;\n        // color: var(--dice-grey-400);\n        color: black;\n      }\n\n      .payout-label {\n        font-size: 11px;\n        color: var(--tooltip-payout);\n      }\n    }\n  }\n}\n\n@keyframes smooth-slide {\n  0% {\n    transform: scale(0) translateY(-100%);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes smooth-slide1 {\n  0% {\n    transform: translateY(-100%);\n  }\n}\n\n@keyframes smooth-slide2 {\n  0% {\n    transform: scale(1) translateY(-100%);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes smooth-slide-x {\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes smooth-slide-x1 {\n  0% {\n    transform: translateX(-100%);\n  }\n}\n\n@keyframes smooth-slide-x2 {\n  0% {\n    transform: translateX(-100%);\n  }\n}\n\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  transform: scale(0.9);\n}\n\nselect option {\n  color: var(--white);\n  background: var(--bgPrimary);\n}\n\ninput[type=\"range\"]:focus::-webkit-slider-runnable-track {\n  background: transparent !important;\n}\n\n.modal .modal-content {\n  background-color: var(--gray-90);\n  border-radius: 15px;\n  color: var(--white);\n\n  @media screen and (max-width: 575.98px) {\n    border-radius: 0;\n  }\n\n  .modal-body {\n    padding: 1.875rem 1.25rem;\n\n    @media screen and (max-width: 1199.98px) {\n      padding: 1.875rem 1rem 5rem 1rem;\n    }\n  }\n\n  .btn-close {\n    width: 1.5rem;\n    max-width: 1.5rem;\n    height: 1.5rem;\n    background-color: var(--gray-60);\n    border: 2px solid var(--gray-90);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100%;\n    padding: 0;\n    position: absolute;\n    top: 0.375rem;\n    right: 0.25rem;\n\n    svg {\n      width: 0.625rem;\n      height: 0.625rem;\n    }\n  }\n\n  .heading-wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 2rem;\n    position: relative;\n\n    .modal-title {\n      color: var(--white);\n      font-size: 2rem;\n      font-weight: 500;\n      line-height: 2.75rem;\n      text-align: center;\n    }\n  }\n\n  .body-wrap {\n    .body-heading {\n      color: var(--white);\n      font-size: 1.125rem;\n      font-weight: 500;\n      margin-bottom: 0.5rem;\n    }\n\n    .form-group {\n      margin-bottom: 1.125rem !important;\n\n      .form-label {\n        color: var(--white);\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1.25rem;\n        margin-bottom: 0.25rem;\n\n        &.form-label-grey {\n          color: var(--white);\n          margin-left: 0.5rem;\n        }\n      }\n\n      .custom-input-group-addons {\n        display: flex;\n        align-items: center;\n        gap: 0.375rem;\n        z-index: 6;\n        padding: 0.625rem 0.5rem;\n\n        img {\n          width: 1.25rem;\n          max-width: 1.25rem;\n          max-height: 1.25rem;\n        }\n\n        .input-btn {\n          height: 1.875rem;\n          background-color: var(--game-color-400);\n          border: 0;\n          border-radius: 0.313rem;\n          color: var(--game-text-100);\n          font-size: 0.875rem;\n          font-weight: 500;\n          line-height: 1.125rem;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          padding: 0.375rem 0.625rem;\n\n          svg {\n            width: 1.25rem;\n            height: 1.25rem;\n            fill: var(--game-text-100);\n\n            path {\n              fill: var(--game-text-100);\n            }\n          }\n\n          &:hover,\n          &.active {\n            background-color: var(--game-primary);\n            color: var(--white);\n\n            svg {\n              fill: var(--white);\n\n              path {\n                fill: var(--white);\n              }\n            }\n          }\n        }\n      }\n\n      .input-group {\n        position: relative;\n\n        .form-control {\n          width: 100%;\n          height: 3.25rem;\n          background-color: var(--game-color-300);\n          border: 1px solid var(--game-border-200);\n          border-radius: 0.375rem;\n          color: var(--game-text-100);\n          font-size: 0.875rem;\n          font-weight: 700;\n          padding: 0.625rem 0.75rem;\n          margin: 0;\n        }\n      }\n    }\n\n    .btn-box {\n      display: flex;\n      flex-direction: column;\n      gap: 0.938rem;\n      margin-top: 0.313rem;\n\n      .btn {\n        border-radius: 0.375rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1.125rem;\n        padding: 1rem;\n      }\n\n      .btn-place-bet {\n        background-color: var(--game-primary);\n        border: 2px solid var(--game-primary);\n        color: var(--white);\n      }\n\n      .btn-place-bet-outline {\n        background-color: transparent;\n        border: 2px solid var(--game-border-300);\n        color: var(--game-text-100);\n      }\n\n      .btn-text {\n        background-color: transparent;\n        border: 0;\n        color: var(--white);\n      }\n    }\n\n    ol {\n      li {\n        font-size: 0.875rem;\n\n        &:not(:last-child) {\n          margin-bottom: 0.125rem;\n        }\n\n        &.game-rules-text {\n          color: var(--game-text-100);\n        }\n      }\n    }\n\n    hr {\n      background-color: var(--game-border-100);\n      opacity: 1;\n      margin: 1rem 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
